var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRadioSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#23A5D4;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24,12c0,3.2-1.3,6.2-3.5,8.5C18.2,22.7,15.2,24,12,24c-3.2,0-6.2-1.3-8.5-3.5C1.3,18.2,0,15.2,0,12 s1.3-6.2,3.5-8.5C5.8,1.3,8.8,0,12,0c3.2,0,6.2,1.3,8.5,3.5C22.7,5.8,24,8.8,24,12z M18.4,7.5c-0.5-0.6-1.5-0.7-2.1-0.1l-6.7,5.8 l-3-3.4C6.1,9.1,5.1,9,4.5,9.6c-0.6,0.5-0.7,1.5-0.1,2.1l3.9,4.5c0.5,0.6,1.4,0.7,2,0.3c0.1,0,0.2-0.1,0.2-0.2l7.7-6.7 C18.8,9.1,18.9,8.1,18.4,7.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioSelected);
export default __webpack_public_path__ + "static/media/radio_selected.b81e11573fc9aea53fbc5e7895473577.svg";
export { ForwardRef as ReactComponent };